module.exports = __webpack_public_path__ + "img/illus-create-connect.7486564b.png";